export default __webpack_public_path__ + "static/media/myjourney-greentree-flower.4dc968d2.svg";